import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

//Catálogo categorías
export const createEditProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/createEditProveedor"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getProveedoresHttp = async () => {
  try {
    const response = await axios.get(`${env.API_URL}/getProveedores`);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const editarProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/editarProveedor`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const desactivarProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/desactivarProveedor`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const activarProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/activarProveedor`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getProveedoresInventarioHttp = async (ids_inventario: number[]) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/getProveedoresPorProductos`,
      { ids_inventario }
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getDocumentosFaltantesProveedorHttp = async (datos?: any) => {
  try {
    const response = await axios.get(`${env.API_URL}/getDocumentosFaltantesProveedor`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const subirDocumentoProveedorHttp = async (formData: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/subirDocumentoProveedor`,
      formData
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const editarDocumentoProveedorHttp = async (formData: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/editarDocumentoProveedor`,
      formData
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};

export const eliminarDocumentoProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.delete(`${env.API_URL}/eliminarDocumentoProveedor`, {
      data,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};